module.exports = __webpack_public_path__ + "img/FB.7434ba50.svg";